import { InfoOutlined } from "@mui/icons-material";
import {
  alpha,
  Box,
  Divider,
  IconButton,
  Popover,
  Typography,
  useTheme,
} from "@mui/material";
import { useState } from "react";

export function GifInfoPopover({ title, img }: { title: string; img: string }) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const theme = useTheme();
  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <InfoOutlined
          sx={{ fontSize: 18, color: theme.palette.text.disabled }}
        />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        disablePortal
        disableRestoreFocus
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: {
              p: 0,
              maxWidth: 380,
              borderRadius: 2,
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              bgcolor: `linear-gradient(135deg, ${theme.palette.background.paper} 80%, ${theme.palette.primary.light} 100%)`,
              border: `1.5px solid ${alpha(theme.palette.primary.main, 0.18)}`,
              backdropFilter: "blur(8px)",
              overflow: "hidden",
              transition: "box-shadow 0.3s, border 0.3s",
            },
            onMouseLeave: handleClose,
          },
        }}
      >
        <Box
          sx={{
            minWidth: 320,
            px: 2,
            py: 1.5,
            display: "flex",
            flexDirection: "column",
            gap: 1,
            background: "none",
          }}
        >
          {title && (
            <>
              <Typography
                variant="subtitle1"
                fontWeight={900}
                sx={{
                  letterSpacing: 0.5,
                  color: theme.palette.primary.main,
                  fontSize: "1.15rem",
                  mb: 0.5,
                  textShadow: `0 2px 8px ${alpha(
                    theme.palette.primary.main,
                    0.08,
                  )}`,
                }}
              >
                {title}
              </Typography>
              <Divider
                sx={{ borderColor: theme.palette.primary.main, mb: 1 }}
              />
            </>
          )}
          <Box sx={{ color: theme.palette.text.primary }}>
            <img
              src={img}
              alt={title}
              style={{
                width: "100%",
                height: "auto",
                borderRadius: 8,
                boxShadow: `0 4px 16px ${alpha(
                  theme.palette.primary.main,
                  0.1,
                )}`,
              }}
            />
          </Box>
        </Box>
      </Popover>
    </>
  );
}
